/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchUserQuestionIdRequest
 */
export interface PatchUserQuestionIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchUserQuestionIdRequest
     */
    title: string;
}

/**
 * Check if a given object implements the PatchUserQuestionIdRequest interface.
 */
export function instanceOfPatchUserQuestionIdRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function PatchUserQuestionIdRequestFromJSON(json: any): PatchUserQuestionIdRequest {
    return PatchUserQuestionIdRequestFromJSONTyped(json, false);
}

export function PatchUserQuestionIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchUserQuestionIdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
    };
}

export function PatchUserQuestionIdRequestToJSON(value?: PatchUserQuestionIdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
    };
}

